module.exports = __webpack_public_path__ + "img/chatu.a8e01411.png";